// extracted by mini-css-extract-plugin
module.exports = {"main":"footer_main__19Qu8","def":"footer_def__nVQiF","header":"footer_header__3Ah3E","middle":"footer_middle__2fEF5"};